import RateCardTableHeader, { RateCardTableHeaderProps } from './RateCardTableHeader';

export type { RateCardTableHeaderProps };
export default RateCardTableHeader;
